import { Modal } from "@mui/material";
import React, { useEffect } from "react";
import { IoCloseCircle } from "react-icons/io5";
import FiberPlanSelector from "./../FiberPlanSelector";
import Swal from "sweetalert2";
import fiberPlanApi from "../../API/FiberPlanApi";
const Index = ({ open, setOpen, customer,setReload }) => {

	const [plan, setPlan] = React.useState(null);
    
    async function handleChangePlan() {
        if (!plan) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Please select a plan",
            });
            return;
        }
        
        const data = {
            id1: customer.id,
            id2: plan.id,
        };

        Swal.fire({
            icon: "info",
            title: "Changing Plan",
            text: "Please wait while we change the plan",
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        const res = await fiberPlanApi.ChangeFiberPlan(data);

        if(res.status.success) {
            Swal.fire({
                icon: "success",
                title: "Success",
                text: "Fiber plan changed successfully",
            });
            setOpen(false);
            setReload((prev) => !prev);
        }
        else {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: res.status.message,
            });
        }


    }

	return (
		<Modal
			open={open}
			onClose={() => {
				setOpen(false);
			}}
		>
			<div
				className="custom_modal"
				style={{
					overflow: "unset",
				}}
			>
				<IoCloseCircle
					onClick={() => {
						setOpen(false);
					}}
					size={30}
					style={{ marginLeft: "auto", cursor: "pointer" }}
					color="#2761d0"
				/>

				<h2 className="text-lg font-semibold">Change Fiber Plan</h2>
				<label className="">Customer Name</label>
				<input type="text" value={customer?.name} disabled />
				<label className="">Fiber Plan</label>
				<div className="w-full">
					<FiberPlanSelector
						fiberCompany={customer.fiberCompanyId}
						setUser={setPlan}
						placeholder="Select Plan"
					/>
				</div>

				<button onClick={() => {handleChangePlan()}}>Change Plan</button>
			</div>
		</Modal>
	);
};

export default Index;
